import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  NgbModal,
  NgbActiveModal,
  ModalDismissReasons,
  NgbPanelChangeEvent,
  NgbAccordion,
} from '@ng-bootstrap/ng-bootstrap';

import {
  AlertService,
  GrowlType,
} from '../../../infrastructure/services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';
import { Language } from 'app/infrastructure/model/classes/resource.class';

const Excel = 'EXCEL';
const JSON  = 'JSON'; 

@Component({
  selector: 'sx-export-modal',
  templateUrl: 'exportModal.component.html',
  styleUrls: ['exportModal.css'],
})
export class ExportModalComponent implements OnInit {
  @Input() isCustom;
  @Input() codOrganization;
  @Input() codSuscription;
  @Input() codChannel;
 
  fileLink: string;
  fileFortmat:string = Excel;
  
  languages: Language[];
  selectedLanguage: Language;
  
  warningMessage: string = '';

  constructor(
    private modal: NgbModal,
    private activeModal: NgbActiveModal,
    private alertService: AlertService,
    private router: Router,
    private route: ActivatedRoute,
    private sxTranslationService: SxTranslationService
  ) {}

  ngOnInit(): void {
    this.sxTranslationService.getAllLanguages()
    .then(response => {
      this.languages = response.result;
    });

  }

  confirmar() {
    this.activeModal.close();
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  onItemChange(value){
    this.fileFortmat = value;
  }

  canExport(){

    if(this.fileFortmat == Excel && this.selectedLanguage == null ){
      this.warningMessage =  this.sxTranslationService.getResource('SOC_IMP_EXP_0004_SELECT_LANGUAGE');
      return false;
    }
  
    return true;
  }

  export(){
    switch ( this.fileFortmat ) {

      case Excel:
        let culture = this.selectedLanguage.culture;
        let urlExcel =  this.sxTranslationService.export(this.isCustom, culture, this.codOrganization, this.codSuscription, this.codChannel )
        .then(response => {
          this.fileLink = response;
        });
       break;
      
      case JSON:
        let urlJSON =  this.sxTranslationService.serialize(this.isCustom, this.codOrganization, this.codSuscription, this.codChannel)
        .then(response => {
          this.fileLink = response;
        });
      break;

      default: 
      // 
      break;
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/exportModal/exportModal.component.ts